import * as PIXI from "pixi.js";
import Main from "../../Main";
import TextureManager from "../../managers/TextureManager";
import SoundManager from "../../managers/SoundManager";
import SoundButtonAnimation from "../../animations/SoundButtonAnimation";
import { ButtonBounds } from "../../types/Interface";


const SOUND_ON = "./images/buttons/sound_on.png";
const SOUND_OFF = "./images/buttons/sound_off.png";


export default class SoundButton extends PIXI.Sprite {
  Main = Main.getInstance();
  currPath: string = SOUND_ON;
  scaleValue = .45;
  constructor(bounds: ButtonBounds, cb: () => void) {
    super();
    Object.assign(this, bounds)
    this.anchor.set(.5);
    this.addTexture(this.currPath)
    this.addInteractivity();
    this.scale.set(this.scaleValue);
  }
  handlePress() {
    if (this.currPath == SOUND_ON) {
      this.currPath = SOUND_OFF;
      SoundManager.muteAll();
    } else {
      this.currPath = SOUND_ON;
      SoundManager.unmuteAll();
    }
    this.exchangeTexture(this.currPath)
  }
  addInteractivity() {
    this.interactive = true;
    this.on("mousedown", () => this.handlePress());
    this.on("touchstart", () => this.handlePress());
  }
  addTexture(path: string) {
    const texture = TextureManager.getTexture(path);
    this.texture = texture;
  }
  exchangeTexture(path: string) {
    new SoundButtonAnimation(this, 0, () => {
      this.addTexture(path);
      this.scale.set(0, this.scaleValue)
      new SoundButtonAnimation(this, this.scaleValue, () => {})
    })
  }
}